import React, { createContext, useContext, useState } from 'react'
import { useNavigate, useParams } from 'react-router';
import { apiAxios } from './Api';

export const AuthContext = createContext();

function AuthProvider({ children }) {

    const [user, setUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem("token") || "");
    const navigate = useNavigate();


    const loginRequest = async (data, page = null) => {
        let fd = new FormData();
        fd.append('username', data.username);
        fd.append('password', data.password);
        const res = await apiAxios("api/login", fd);
        if (res) {
            //setUser(res);
            if (res.token) {
                setToken(res.token);
                localStorage.setItem("token", res.token);
                if (page)
                    navigate(page)
                else
                    navigate("/recherche");
            }
            return;
        }
        //throw new Error(res.message);
    };

    const logOut = () => {
        setUser(null);
        setToken("");
        localStorage.removeItem("token");
        navigate("/login");
    };

    return (
        <AuthContext.Provider value={{ token, user, loginRequest, logOut }}>
            {children}
        </AuthContext.Provider>
    );
}

export default AuthProvider

export const useAuth = () => {
    return useContext(AuthContext)
}